import defaultProfilePicUrl from 'assets/images/default_profile_pic.jpg';

function AccountProfileCtrl($scope, managementUserService, sdkUtils, alertService, ERROR_MESSAGES, formHelpersService) {

  _initScope();

  _getCurrentUser()
    .finally(() => {
      $scope.loading = false;
    });

  function _initScope() {
    $scope.defaultProfilePicUrl = defaultProfilePicUrl;

    /**
     * @desc Update the current user's profile
     */
    $scope.update = function (form) {
      if (!form) throw new Error('form is required');

      if (!form.$valid) {
        alertService.error(formHelpersService.getFormErrors(form));
        return;
      }

      // Extract data to send to API
      const payload = formHelpersService.getChangedFormValues(form);

      $scope.savingUser = true;

      managementUserService.updateMe(payload)
        .then(() => {
          alertService.success('Account updated.');

          _getCurrentUser();
        })
        .catch(response => {
          alertService.error(sdkUtils.getErrorFromResponse(response));
        })
        .finally(() => {
          $scope.savingUser = false;
        });
    };
  }

  /**
   * @desc Load the currently logged in user's profile
   */
  function _getCurrentUser() {
    return managementUserService.me()
      .then((user) => {
        $scope.user = user;
      })
      .catch(() => {
        alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_CURRENT_USER);
      });
  }
}

AccountProfileCtrl.$inject = [
  '$scope',
  'jsSdk.managementUser',
  'jsSdk.utils',
  'alertService',
  'ERROR_MESSAGES',
  'formHelpersService'
];

export default AccountProfileCtrl;



// WEBPACK FOOTER //
// ./src/components/accountProfile/accountProfileCtrl.js